import { FormSectionIdEnum } from "@/enums";

export const FORM_SECTION_DEFAULT_OPEN_BY_ID: Readonly<
  Record<FormSectionIdEnum, boolean>
> = {
  // Common sections at the top
  [FormSectionIdEnum.BASICS]: true,

  // Domain sections
  [FormSectionIdEnum.ASSESSMENT]: true,
  [FormSectionIdEnum.PRESETS]: false,
  [FormSectionIdEnum.CONNECTIONS]: false,
  [FormSectionIdEnum.COMPATIBILITY]: false,
  [FormSectionIdEnum.SPECS]: false,
  [FormSectionIdEnum.INPUT_SPECS]: true,
  [FormSectionIdEnum.OUTPUT_SPECS]: true,
  [FormSectionIdEnum.INPUT_BINDINGS]: true,
  [FormSectionIdEnum.OUTPUT_BINDINGS]: true,
  [FormSectionIdEnum.PATTERN]: false,
  [FormSectionIdEnum.SEMANTICS]: false,
  [FormSectionIdEnum.SCIENCE]: false,
  [FormSectionIdEnum.CONFIGURATION]: false,
  [FormSectionIdEnum.SIMULATION]: true,

  // Exercise scheduling
  [FormSectionIdEnum.BEHAVIOR]: false,
  [FormSectionIdEnum.PRIORITIZATION]: false,
  [FormSectionIdEnum.SUITABILITY]: false,
  [FormSectionIdEnum.CAMPAIGNS]: false,
  [FormSectionIdEnum.LIMITS]: false,

  // Common sections at the bottom
  [FormSectionIdEnum.SETTINGS]: false,
  [FormSectionIdEnum.SECURITY]: false,
  [FormSectionIdEnum.STATUS]: true,
};

export const FORM_SECTION_PERSIST_OPEN_STATE_GLOBALLY_BY_ID: Readonly<
  Record<FormSectionIdEnum, boolean>
> = {
  // Common sections at the top
  [FormSectionIdEnum.BASICS]: true,

  // Domain sections
  [FormSectionIdEnum.ASSESSMENT]: false,
  [FormSectionIdEnum.PRESETS]: false,
  [FormSectionIdEnum.CONNECTIONS]: false,
  [FormSectionIdEnum.COMPATIBILITY]: false,
  [FormSectionIdEnum.SPECS]: false,
  [FormSectionIdEnum.INPUT_SPECS]: false,
  [FormSectionIdEnum.OUTPUT_SPECS]: false,
  [FormSectionIdEnum.INPUT_BINDINGS]: false,
  [FormSectionIdEnum.OUTPUT_BINDINGS]: false,
  [FormSectionIdEnum.PATTERN]: false,
  [FormSectionIdEnum.SEMANTICS]: true,
  [FormSectionIdEnum.SCIENCE]: false,
  [FormSectionIdEnum.CONFIGURATION]: false,
  [FormSectionIdEnum.SIMULATION]: false,

  // Exercise scheduling
  [FormSectionIdEnum.BEHAVIOR]: false,
  [FormSectionIdEnum.PRIORITIZATION]: false,
  [FormSectionIdEnum.SUITABILITY]: false,
  [FormSectionIdEnum.CAMPAIGNS]: false,
  [FormSectionIdEnum.LIMITS]: false,

  // Common sections at the bottom
  [FormSectionIdEnum.SETTINGS]: false,
  [FormSectionIdEnum.SECURITY]: true,
  [FormSectionIdEnum.STATUS]: true,
};
